import React, { useEffect, useRef } from "react";
import { FiMail, FiLinkedin, FiGithub } from "react-icons/fi";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion, EASE } from "../utils/motion";

gsap.registerPlugin(ScrollTrigger);

const Contact = ({ onOpenContactForm }) => {
  const sectionRef = useRef(null);

  // Section reveal — robust: content visible by default, animation is enhancement only
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    if (prefersReducedMotion()) return;

    const ctx = gsap.context(() => {
      // Each element gets its own trigger with immediateRender:false
      // so content is NEVER pre-hidden — animation only enhances on scroll-in.

      gsap.from(el.querySelector(".carousel-title"), {
        opacity: 0,
        y: -22,
        duration: 0.85,
        ease: EASE.strong,
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none reset",
        },
      });

      gsap.from(el.querySelector(".contact-description"), {
        opacity: 0,
        y: 22,
        duration: 0.65,
        delay: 0.15,
        ease: EASE.standard,
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none reset",
        },
      });

      gsap.from(el.querySelectorAll(".contact-button"), {
        opacity: 0,
        y: 20,
        scale: 0.95,
        duration: 0.52,
        stagger: 0.09,
        delay: 0.28,
        ease: EASE.spring,
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none reset",
        },
      });
    }, el);

    return () => ctx.revert();
  }, []);

  return (
    <section className="carousel-section contact-section" id="contact" ref={sectionRef}>
      {/* Static ambient orbs — purely decorative CSS, no JS animation */}
      <div className="contact-orb contact-orb-1" aria-hidden="true" />
      <div className="contact-orb contact-orb-2" aria-hidden="true" />

      <h2 className="carousel-title">Let's Build Something Amazing</h2>

      <div className="contact-container">
        <div className="contact-content">
          <p className="contact-description">
            Ready to turn your ideas into products? Get in touch directly to discuss your project.
          </p>

          <div className="contact-methods">
            <button
              type="button"
              className="contact-button contact-button-primary"
              onClick={(e) => {
                e.preventDefault();
                onOpenContactForm?.();
              }}
            >
              <FiMail className="contact-icon" /> Get In Touch
            </button>

            <a
              href="https://linkedin.com/in/morpheus-vibaen-j"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
            >
              <FiLinkedin className="contact-icon" /> LinkedIn
            </a>

            <a
              href="https://github.com/Vibaen"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
            >
              <FiGithub className="contact-icon" /> GitHub
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
